import React from "react";
import { Descriptions, Typography } from "antd";
const { Title } = Typography;

const AnswerBotProspectAccountFailed = ({ resource }) => {
  return (
    <>
      <Title level={4}>Order Information</Title>
      <Descriptions column={1} layout="vertical" size="small">
        <Descriptions.Item label="Purpose">Answer Bot Prospect Account Failed</Descriptions.Item>
        <Descriptions.Item label="Member ID">{resource.member_id}</Descriptions.Item>
        <Descriptions.Item label="Member Email">{resource.member_email}</Descriptions.Item>
        <Descriptions.Item label="Member Subscription ID">{resource.member_subscription_id}</Descriptions.Item>
        <Descriptions.Item label="Contact ID">{resource.contact_id}</Descriptions.Item>
      </Descriptions>
    </>
  );
};

export default AnswerBotProspectAccountFailed; 